import api from "./api";

/**
 * WhatsApp Templates API Service
 */

/**
 * Get all templates for the company
 * @param {Object} filters - Optional filters (whatsappId, status, category, search)
 * @returns {Promise<Array>} List of templates
 */
export const getTemplates = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.whatsappId) params.append("whatsappId", filters.whatsappId);
  if (filters.status) params.append("status", filters.status);
  if (filters.category) params.append("category", filters.category);
  if (filters.search) params.append("search", filters.search);
  if (filters.activeOnly !== undefined) params.append("activeOnly", filters.activeOnly);

  const response = await api.get(`/whatsapp-templates?${params.toString()}`);
  return response.data;
};

/**
 * Get templates for quick menu (simplified list)
 * @param {number} whatsappId - Optional WhatsApp ID filter
 * @returns {Promise<Array>} List of quick menu items
 */
export const getQuickMenuTemplates = async (whatsappId) => {
  const params = whatsappId ? `?whatsappId=${whatsappId}` : "";
  const response = await api.get(`/whatsapp-templates/quick-menu${params}`);
  return response.data;
};

/**
 * Get a single template by ID
 * @param {number} id - Template ID
 * @returns {Promise<Object>} Template details
 */
export const getTemplate = async (id) => {
  const response = await api.get(`/whatsapp-templates/${id}`);
  return response.data;
};

/**
 * Sync templates from Meta API
 * @param {number} whatsappId - WhatsApp connection ID
 * @returns {Promise<Object>} Sync result
 */
export const syncTemplates = async (whatsappId) => {
  const response = await api.post(`/whatsapp-templates/sync/${whatsappId}`);
  return response.data;
};

/**
 * Send a template message
 * @param {Object} data - { templateId, ticketId, parameters }
 * @returns {Promise<Object>} Send result
 */
export const sendTemplateMessage = async (data) => {
  const response = await api.post("/whatsapp-templates/send", data);
  return response.data;
};

/**
 * Update template local settings
 * @param {number} id - Template ID
 * @param {Object} data - { isActive, variables }
 * @returns {Promise<Object>} Updated template
 */
export const updateTemplate = async (id, data) => {
  const response = await api.put(`/whatsapp-templates/${id}`, data);
  return response.data;
};








